import slide1 from "../../assets/images/slide-1.jpg";
import slide2 from "../../assets/images/slide-2.jpeg";
import slide3 from "../../assets/images/slide-3.jpeg";

export const SLIDES = [
  {
    id: 0,
    title: "Un viaje para ver un show de BZRP",
    description:
      "Completa el álbum y participa por un viaje todo incluído para ver un show de Bizarrap donde más te guste.",
    image: slide1,
    alternativeTitle: "alternative title1",
  },
  {
    id: 1,
    title: "Comunidad en Discord",
    description:
      "Conocé más jugadores dentro de los distintos canales de Discord. Participá de la comunidad para ser parte de experiencias y beneficios únicos!",
    image: slide2,
    alternativeTitle: "alternative title2",
  },
  {
    id: 2,
    title: "Exclusivo para los fans",
    description:
      "En nuestras redes sociales podrás participar por sorteos y concursos exclusivos para la comunidad de Bizarrap!",
    image: slide3,
    alternativeTitle: "alternative title3",
  },
];
